export default{
    lawServe:{
        Description:{
            title:'法律服务',
            module1:{
                title:'专业法律服务资源',
                btn:'查看详情',
                box1:{
                    title:'企业跨境贸易投资法律服务',
                    text:'一站式涉外商事法务，覆盖跨境合规（出口管制/反垄断）、知识产权保护、贸易争端化解全链路服务，赋能企业防控风险、稳健出海。',
                },
                box2:{
                    title:'中国企业境外商务投诉服务',
                    text:'商务部公共维权服务，免费提供跨境纠纷应对咨询与投诉受理，覆盖贸易摩擦预警、反商业欺诈指导及海外权益保障，护航企业合规出海。',
                },
                box3:{
                    title:'法律服务热线',
                    text:'提供法律咨询、法律服务指引、法律法规查询、案例库查询、法律援助、公证办理、司法鉴定、仲裁服务等多种公共法律服务。',
                },
            },
            module2:{
                title:'属地法务快捷入口',
                box1:{
                    text:'人民调解',
                },
                box2:{
                    text:'公证业务',
                },
                box3:{
                    text:'法律援助',
                },
            },
            module3:{
                title:'法律服务，助力企业应对复杂国际法律环境',
                text:'在全球贸易的大背景下，农业服务贸易同样面临着复杂的法律环境和多样化的挑战——从跨境合同的签订与执行、知识产权的有效保护到遵循各国不同的合规要求，每一个环节都可能存在潜在风险。法律服务致力于为企业提供一站式法律解决方案，整合国际化律师团队与多国法律资源，帮助客户规避风险、维护权益、高效解决争议，助力企业全球业务行稳致远。',
                imgBox1:{
                    title:'跨境合同审查与起草',
                    text1:'审核国际采购、分销、投资协议条款，确保符合目标国法律，规避隐性风险',
                    text2:'提供多语言合同模板（中、英、西语等），支持快速定制。'
                },
                imgBox2:{
                    title:'知识产权全球保护',
                    text1:'国际商标、专利、版权注册与维权，应对侵权纠纷。',
                    text2:'监测全球知识产权动态，提供预警与战略建议。'
                },
                imgBox3:{
                    title:'国际仲裁与诉讼代理',
                    text1:'代理跨境商业纠纷、债务追偿、反倾销诉讼等案件。',
                    text2:'对接国际仲裁机构（如ICC、SIAC），缩短争议解决周期。'
                },
                imgBox4:{
                    title:'合规与监管咨询',
                    text1:'解读欧盟GDPR、美国出口管制等法规，确保数据隐私与贸易合规。',
                    text2:'设计跨境税务架构，规避双重征税与合规风险。'
                },
                imgBox5:{
                    title:'国际贸易协议支持',
                    text1:'分析RCEP、CPTPP等区域协定，优化供应链布局。',
                    text2:'应对贸易壁垒，提供反补贴、反倾销法律应对方案。'
                },
                imgBox6:{
                    title:'法律风险管理',
                    text1:'定制国别法律风险评估报告，覆盖劳动法、环保法等领域。',
                    text2:'提供应急预案，应对突发法律事件（如制裁、海关扣押）。'
                },
            }
        } 
    }
}